import React from 'react'

const OverviewButton = ({ activeTab, setActiveTab }) => {
    const extraScroll = window.innerWidth <= 990 ? 850 : 0;

    return (
        <div
            className={`tab-button ${activeTab === "overview" ? "active" : ""
                }`}
            onClick={() => {
                setActiveTab();
                window.scrollTo({
                    top: window.innerHeight * 0.8 + extraScroll,
                    behavior: "smooth",
                });
            }}
        >
            <span className="overview-icon">
                <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.33333 2.16667C5.22827 2.16667 4.16846 2.60565 3.38706 3.38706C2.60565 4.16846 2.16667 5.22827 2.16667 6.33333V29.6667C2.16667 30.7717 2.60565 31.8315 3.38706 32.6129C4.16846 33.3943 5.22827 33.8333 6.33333 33.8333H19.6667V35.5H6.33333C4.78624 35.5 3.30251 34.8854 2.20854 33.7915C1.11458 32.6975 0.5 31.2138 0.5 29.6667V6.33333C0.5 4.78624 1.11458 3.30251 2.20854 2.20855C3.30251 1.11458 4.78624 0.500001 6.33333 0.500001H18C18.1095 0.499806 18.218 0.521196 18.3192 0.562949C18.4205 0.604701 18.5125 0.665998 18.59 0.743335L28.59 10.7433C28.6673 10.8209 28.7286 10.9129 28.7704 11.0141C28.8121 11.1154 28.8335 11.2238 28.8333 11.3333V14.6667H27.1667V11.6783L17.655 2.16667H6.33333Z"
                        fill="#414141"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M17.6815 0.563308C17.8337 0.500117 18.0013 0.48349 18.163 0.51553C18.3247 0.54757 18.4732 0.626837 18.5898 0.743308L28.5898 10.7433C28.7067 10.8599 28.7863 11.0085 28.8186 11.1703C28.8508 11.3322 28.8343 11.5 28.7711 11.6524C28.7079 11.8049 28.6009 11.9351 28.4636 12.0267C28.3263 12.1182 28.1649 12.1669 27.9998 12.1666H22.9998C21.4527 12.1666 19.969 11.5521 18.875 10.4581C17.7811 9.36414 17.1665 7.8804 17.1665 6.33331V1.33331C17.1665 1.16841 17.2155 1.00722 17.3072 0.870156C17.3988 0.733088 17.5291 0.6263 17.6815 0.563308ZM18.8332 3.34664V6.33331C18.8332 7.43838 19.2722 8.49819 20.0536 9.27959C20.835 10.061 21.8948 10.5 22.9998 10.5H25.9882L18.8332 3.34664ZM23.8332 18.8333C22.5071 18.8333 21.2353 19.3601 20.2976 20.2978C19.36 21.2355 18.8332 22.5072 18.8332 23.8333C18.8332 25.1594 19.36 26.4312 20.2976 27.3688C21.2353 28.3065 22.5071 28.8333 23.8332 28.8333C25.1593 28.8333 26.431 28.3065 27.3687 27.3688C28.3064 26.4312 28.8332 25.1594 28.8332 23.8333C28.8332 22.5072 28.3064 21.2355 27.3687 20.2978C26.431 19.3601 25.1593 18.8333 23.8332 18.8333ZM17.1665 23.8333C17.1665 22.0652 17.8689 20.3695 19.1191 19.1193C20.3694 17.869 22.0651 17.1666 23.8332 17.1666C25.6013 17.1666 27.297 17.869 28.5472 19.1193C29.7975 20.3695 30.4998 22.0652 30.4998 23.8333C30.4998 25.6014 29.7975 27.2971 28.5472 28.5474C27.297 29.7976 25.6013 30.5 23.8332 30.5C22.0651 30.5 20.3694 29.7976 19.1191 28.5474C17.8689 27.2971 17.1665 25.6014 17.1665 23.8333Z"
                        fill="#414141"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M28.5902 27.41L35.2568 34.0766L34.0785 35.2566L27.4118 28.59L28.5902 27.41ZM14.6668 10.5H6.3335V8.83331H14.6668V10.5ZM14.6668 18.8333H6.3335V17.1666H14.6668V18.8333ZM14.6668 27.1666H6.3335V25.5H14.6668V27.1666Z"
                        fill="#414141"
                    />
                </svg>
            </span>{" "}
            <span>Overview</span>
        </div>
    )
}

export default OverviewButton